import sleep from '../helpers/sleep';

class SupplierGrid {

    init() {
        console.log('SupplierGrid init');
        this.animationDuration = 800;
        this.currentInsertPosition = null;

        this.gridElement = document.querySelector('.supplier-grid');
        if (this.gridElement == null) return;

        this.suppliers = this.gridElement.querySelectorAll('.supplier');
        this.previewElement = this.gridElement.querySelector('.supplier-preview');

        this.bind();
    }

    bind() {
        this.suppliers.forEach((supplier) =>
            supplier.addEventListener('click', this.togglePreview.bind(this))
        );

        this.previewElement.querySelector('.supplier-preview__close').addEventListener('click', this.closePreview.bind(this));
        window.addEventListener('resize', this.closePreview.bind(this));
    }

    getInsertPosition(supplier) {
        let parent = supplier.parentNode;

        let nodeWidth = supplier.clientWidth;
        let parentWidth = parent.clientWidth;

        let elementIndex = [...parent.children].indexOf(supplier);
        let elementsPerLine = Math.floor(parentWidth / nodeWidth);

        let lineNumber = Math.floor(elementIndex / elementsPerLine);
        return (lineNumber + 1) * elementsPerLine;
    }

    async togglePreview(event) {
        let supplier = event.currentTarget;
        if (supplier.classList.contains('-current')) {
            console.log('Close');

            this.closePreview(event);
        } else {
            console.log('Open');
            this.openPreview(event);
        }
    }

    async closePreview(event) {
        await this.removeSupplierInfo();
    }

    async openPreview(event) {
        let supplier = event.currentTarget;
        let insertPosition = this.getInsertPosition(supplier);

        console.log('Current IP', this.currentInsertPosition, insertPosition, this.currentInsertPositon != null, insertPosition != this.currentInsertPosition);

        if (this.currentInsertPosition != null &&
            insertPosition != this.currentInsertPosition) {
            await this.removeSupplierInfo();
        } else {
            this.toggleMarker();
        }

        await sleep(20);

        await this.updatePreviewData(supplier);

        if (insertPosition != this.currentInsertPosition) {
            this.addSupplierInfo(supplier);
        } else {
            supplier.classList.add('-current');
        }
    }

    toggleMarker() {
        let currentSupplier = this.gridElement.querySelector('.-current');

        if (currentSupplier != null) {
            console.log('Current', currentSupplier.classList);
            currentSupplier.classList.remove('-current');
        }
    }

    async removeSupplierInfo() {
        return new Promise(async (res, rej) => {

            this.previewElement.style.height = this.previewElement.clientHeight + 'px';
            await sleep(10);
            this.previewElement.style.height = '';
            await sleep(this.animationDuration);

            this.currentInsertPosition = null;
            this.gridElement.removeChild(this.previewElement);
            this.toggleMarker();
            res();
        });
    }

    calculatePreviewElementHeight() {
        this.previewElement.style.position = 'absolute';
        this.previewElement.style.left = 0;
        this.previewElement.style.width = '100%';
        this.previewElement.style.height = 'auto';
        this.previewElement.style.opacity = 0;

        this.gridElement.appendChild(this.previewElement);
        return this.previewElement.clientHeight;
    }

    async addSupplierInfo(supplier) {
        return new Promise(async (res, rej) => {
            console.log('Add Supplier Info');

            let insertPosition = this.getInsertPosition(supplier);
            let height = this.calculatePreviewElementHeight();

            this.previewElement.style.position = 'relative';
            this.previewElement.style.left = '';
            this.previewElement.style.width = '';
            this.previewElement.style.height = '';
            this.previewElement.style.opacity = 1;

            this.gridElement.removeChild(this.previewElement);
            this.gridElement.insertBefore(this.previewElement, this.suppliers[insertPosition]);

            await sleep(10);
            this.previewElement.style.height = height + 'px';
            supplier.classList.add('-current');
            await sleep(this.animationDuration);
            this.previewElement.style.height = 'auto';
            this.currentInsertPosition = insertPosition;
            res();
        });
    }

    updatePreviewData(supplier) {
        let data = supplier.getAttribute('data-supplier');
        data = JSON.parse(data);

        if (data.image) {
            this.previewElement.querySelector('.supplier-preview__image img').src = data.image;
            this.previewElement.querySelector('.supplier-preview__image img').style.display = 'block';
        } else {
            this.previewElement.querySelector('.supplier-preview__image img').style.display = 'none';
        }

        this.previewElement.querySelector('.supplier-preview__title').innerHTML = data.title || '';
        this.previewElement.querySelector('.supplier-preview__excerpt').innerHTML = data.content || '';
        this.previewElement.querySelector('.supplier-preview__link').href = data.permalink || '';

    }
}

export default new SupplierGrid();